import { useCallback } from 'react'
import { useTooltipContext } from './Tooltip'
import type { TriggerProps } from './types'

export const Trigger: React.FC<React.PropsWithChildren<TriggerProps>> = ({
  children,
  onClick,
  tooltipId,
}) => {
  const { onOpen, onClose } = useTooltipContext()

  const handlePointerEnter = useCallback(
    (event: React.PointerEvent<HTMLElement>) => {
      if (event.pointerType === 'mouse') onOpen()
    },
    [onOpen],
  )

  const handlePointerLeave = useCallback(
    (event: React.PointerEvent<HTMLElement>) => {
      if (event.pointerType === 'mouse') onClose()
    },
    [onClose],
  )

  const handleFocus = useCallback(() => onOpen(), [onOpen])

  const handleBlur = useCallback(() => onClose(), [onClose])

  return (
    <div
      className="cursor-pointer"
      aria-describedby={tooltipId}
      onClick={onClick}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      {children}
    </div>
  )
}
